import { Button } from "@/components/ui/button";
import { Sparkles, X } from "lucide-react";
import { useState, useEffect } from "react";
import { useKopfaiClickTracking } from "@/hooks/useKopfaiClickTracking";

export function CTABanner() {
  const { trackClick } = useKopfaiClickTracking();
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if banner was dismissed
    const dismissed = localStorage.getItem("ctaBannerDismissed");
    if (dismissed) {
      setIsDismissed(true);
      return;
    }

    // Show banner after scrolling down a bit
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem("ctaBannerDismissed", "true");
  };

  if (isDismissed || !isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gradient-to-r from-kopf-primary via-kopf-primary to-kopf-accent text-kopf-white shadow-2xl z-40 animate-slide-in-right">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex-1 flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <div className="flex items-center gap-2">
              <div className="bg-kopf-white/20 p-2 rounded-lg">
                <Sparkles className="w-4 h-4 sm:w-5 sm:h-5 text-kopf-white" />
              </div>
              <div>
                <h3 className="text-sm sm:text-base md:text-lg font-bold">Precisa de apoio emocional?</h3>
                <p className="text-kopf-white/90 text-xs sm:text-sm">Experimente conversar com a KopfAI</p>
              </div>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <Button
              asChild
              size="sm"
              className="bg-kopf-white text-kopf-primary hover:bg-kopf-white/90 font-bold shrink-0 shadow-lg text-xs sm:text-sm"
            >
              <a
                href="https://kopfai.com/ref/P4N9NKTN"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackClick("banner", null, "Começar Grátis")}
              >
                Experimentar agora
              </a>
            </Button>
            <Button
              variant="ghost"
              size="icon"
              onClick={handleDismiss}
              className="text-kopf-white hover:bg-kopf-white/20 shrink-0"
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
